/**
 * Internal dependencies
 */
import { setup } from './setup.js';
import { submit } from './submit.js';
import { getElementStyle } from './utils.js';
import { onPaymentFormError as onError } from '@wpsimplepay/core/frontend/payment-forms';

export default {
	setup,
	submit,
	onError,
	getElementStyle,
};
